module.exports = __webpack_public_path__ + "img/Snipaste.f441d9cb.png";